// Part of the opponent's name.
import { ownerColour } from '../classify.ts';
import { text, type FilterCriterion } from '../criterion.ts';
import { byFrequency } from '../suggest.ts';

export const opponent: FilterCriterion<'opponent'> = {
  key: 'opponent',
  query: 'opponent',
  ...text,
  matches: (game, v) => {
    const colour = ownerColour(game);
    const name = colour === 'white' ? game.black.name : colour === 'black' ? game.white.name : `${game.white.name} ${game.black.name}`;
    return name.toLowerCase().includes(v.trim().toLowerCase());
  },
  control: {
    kind: 'text',
    order: 80,
    label: 'Name',
    placeholder: "Opponent's name",
    // The opponents met, most often first.
    suggest: (games) =>
      byFrequency(
        games.map((g) => {
          const colour = ownerColour(g);
          return colour === 'white' ? g.black.name : colour === 'black' ? g.white.name : undefined;
        }),
      ),
  },
};
